import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import HeaderPortal from 'components/layout/HeaderPortal';
import NumericPrecisionsListContainer from './NumericPrecisionsListContainer';
import { ADMIN_FIELD_DECIMAL_PLACES_CONFIG_READ } from 'constants/rightsCodes';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}></Portal>
      <PermissionCheck authorizationCode={ADMIN_FIELD_DECIMAL_PLACES_CONFIG_READ}>
        <NumericPrecisionsListContainer />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
